import { Badge } from '@mantine/core'
import type { AgentSessionProps, IssueDetailProps, IssueSummaryProps, ProjectProps } from '@/types'

export function ProjectTypeBadge({ type }: { type: ProjectProps['project_type'] }) {
  if (type === 'global') return <Badge color="blue" variant="light">Global</Badge>
  if (type === 'folder') return <Badge color="gray" variant="light">Folder</Badge>
  return <Badge color="teal" variant="light">Project</Badge>
}

export function SessionStatusBadge({ status }: { status: AgentSessionProps['status'] }) {
  const color = status === 'failed'
    ? 'red'
    : status === 'waiting_for_user'
      ? 'yellow'
      : status === 'running' || status === 'queued'
        ? 'blue'
        : 'gray'

  const label = status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ')
  return <Badge color={color} variant="light">{label}</Badge>
}

export function IssueStateBadge({ state }: { state: IssueSummaryProps['state'] | IssueDetailProps['state'] }) {
  const color = state === 'open'
    ? 'teal'
    : state === 'in_progress'
      ? 'blue'
      : state === 'feedback_required'
        ? 'yellow'
        : state === 'feedback_provided'
          ? 'indigo'
          : 'gray'

  const label = state.replace(/_/g, ' ')
  return <Badge color={color} variant="light">{label}</Badge>
}

export function IssueTypeBadge({ issueType }: { issueType: IssueSummaryProps['issue_type'] | IssueDetailProps['issue_type'] }) {
  if (issueType === 'generic') return null
  return <Badge color="gray" variant="outline">{issueType}</Badge>
}

export function ActorBadge({ type }: { type: 'user' | 'agent' }) {
  return (
    <Badge color={type === 'agent' ? 'violet' : 'gray'} variant="light">
      {type}
    </Badge>
  )
}
